import React from 'react';

import { Trans } from 'react-i18next';
import {
  Callout,
  Button,
  FormGroup,
  Dialog,
  Classes,
  InputGroup,
  Card,
  H5,
  Tag,
  Switch,
  ControlGroup,
  MenuItem,
  Position,
  OverlayToaster
} from '@blueprintjs/core';
import { MultiSelect } from '@blueprintjs/select';

import {
  bonitickAuthenticatedPostFetchWithResult,
  bonitickAuthenticatedPatchFetch,
} from '../../../src/utils/BonitickAuthenticatedFetch';

import {
  getProfilLookup,
  getDiscountLookup
} from './lookup';

import i18n from 'i18next';

export class Profil extends React.Component {
  constructor(props) {
    super();
    this.state = {
      profils: [],
      discounts: [],
      label: undefined,
      id: undefined,
      Items: [],
      Item: [],
      ItemsId: [],
      addProfil: false,
      editProfil: false
    };
  }

  toasterRef = React.createRef();

  showToaster(msg, intent, icon) {
    this.toasterRef.current?.show({
      message: msg,
      intent: intent,
      icon: icon
    });
  }


  disableButton() {
    const { label, discounts, active } = this.state;
    return !(label && discounts && active);
  }

  disableProfilUpdateButton() {
    const { label, discounts, ItemsId } = this.state;
    return !(label?.length > 0 && discounts && ItemsId.length > 0);
  }
  disableProfileButton() {
    const { label } = this.state;
    return !label?.length > 0;
  }

  async updateCard() {
    const profils = await getProfilLookup();
    this.setState({ profils });
  }

  async updateDiscounts() {
    const discounts = await getDiscountLookup();
    this.setState({ discounts });
  }

  async createProfil() {
    return new Promise((res, rej) => {
      bonitickAuthenticatedPostFetchWithResult('/bonification/profil', { label: this.state.label, active: true },
        (status, data) => {
          if (status === 200) {
            const profils = [...this.state.profils]
            profils.push({ label: this.state.label, active: true, id: data.id })
            localStorage.setItem('profilLookup', JSON.stringify(profils));
            this.setState({ addProfil: false, profils });
            this.showToaster('Profil added successfully', 'success', 'tick');
          }
        },
        (e) => {
          this.showToaster(i18n.t(`label must be unique, please verify`), "danger", "error");
        }
      )
    });
  }

  getProfilById(profils, id) {
    return profils.filter(p => p.id === id);
  }

  updateVendorProfil(profils) {
    const vendors = JSON.parse(localStorage.getItem('vendorLookup'));
    vendors.forEach(v => {
      v.profil = this.getProfilById(profils, v.profil?.id)[0];
      v.users.forEach(u => {
        u.profil = this.getProfilById(profils, u.idProfil)[0];
      })
    })
    localStorage.setItem('vendorLookup', JSON.stringify(vendors));

    this.props.updated();
  }

  async updateProfil() {
    return new Promise((res, rej) => {
      bonitickAuthenticatedPatchFetch(
        '/bonification/profil',
        {
          idProfil: this.state.id,
          label: this.state.label,
          idDiscounts: this.state.ItemsId,
          active: this.state.active
        }, () => {
          const index = this.state.profils.findIndex(p => p.id === this.state.id);
          if (index !== -1) {
            const profilsUpdate = [...this.state.profils];
            profilsUpdate[index].active = this.state.active;
            profilsUpdate[index].label = this.state.label;
            profilsUpdate[index].discounts = [];
            this.state.ItemsId.forEach(i => {
              const index2 = this.state.discounts.findIndex(d => d.id === i);
              if (index2 !== -1) {
                const dist = { ...this.state.discounts[index2] };
                profilsUpdate[index].discounts.push(dist);
              }
            });
            localStorage.setItem('profilLookup', JSON.stringify(profilsUpdate));
            this.updateVendorProfil(profilsUpdate);
            this.showToaster('Profil updated successfully', 'success', 'tick');
            this.setState({ Items: [], ItemsId: [], editProfil: false, profils: profilsUpdate });
          }
        }, (e) => {
          this.showToaster(`Error : ${e?.message}`, "danger", "error");
          this.setState({ Items: [], ItemsId: [], editProfil: false });
        });
    });
  }

  async componentDidMount() {
    await this.updateCard();
    await this.updateDiscounts();
  }


  render() {
    return (
      <div>
        <Callout title={<Trans>profil</Trans>} intent="primary" icon="label">
          <Button icon="add" text={i18n.t("add")} onClick={() => this.setState({ addProfil: true })} />
          <Dialog
            style={{ transition: 'none' }}
            isOpen={this.state.addProfil}
            canEscapeKeyClose={true}
            canOutsideClickClose={true}
            onClose={() => this.setState({ addProfil: false, label: '' })}
            title={<Trans>add a profil</Trans>}
          >
            <div className={Classes.DIALOG_BODY}>
              <FormGroup label={<Trans>label</Trans>} labelFor="input_label">
                <InputGroup
                  id="input_label"
                  onChange={(ti) => this.setState({ label: ti.target.value })}
                  leftIcon="label"
                  large={true}
                  intent={'primary'}
                  placeholder={'label'}
                />
              </FormGroup>

              <div className="flexbox-center">
                <FormGroup>
                  <Button
                    text={<Trans>add</Trans>}
                    intent="primary"
                    type="submit"
                    icon="add"
                    disabled={this.disableProfileButton()}
                    onClick={async () => {
                      await this.createProfil();
                    }}
                  />
                  <Button
                    text={<Trans>cancel</Trans>}
                    intent="warning"
                    icon="undo"
                    style={{ marginLeft: '5px' }}
                    onClick={() => this.setState({ addProfil: false })}
                  />
                </FormGroup>
              </div>
            </div>
          </Dialog>

          <Dialog
            style={{ transition: 'none' }}
            isOpen={this.state.editProfil}
            canEscapeKeyClose={true}
            canOutsideClickClose={true}
            onClose={() => this.setState({ editProfil: false })}
            title={<Trans>update profil</Trans>}
          >
            <div className={Classes.DIALOG_BODY}>

              <FormGroup label={<Trans>label</Trans>} labelFor="input_label">
                <InputGroup
                  id="input_label"
                  onChange={(ti) => this.setState({ label: ti.target.value })}
                  leftIcon="label"
                  large={true}
                  value={this.state.label}
                />
              </FormGroup>

              <FormGroup label={<Trans>accepted bonifications</Trans>} labelFor="input_bonification">
                <ControlGroup fill={true}>
                  <MultiSelect
                    activeItem={this.state.Item}
                    items={this.state.discounts}
                    selectedItems={this.state.Items}
                    itemRenderer={(val, itemProps) => {
                      return (
                        <MenuItem
                          key={val.id}
                          text={val.label}
                          icon={'tag'}
                          disabled={this.state.Items.includes(val.label)}
                          onClick={(elm) => {
                            if (this.state.Items.includes(elm.target.textContent)) {
                              this.setState({
                                Items: this.state.Items.filter((i) => i !== elm.target.textContent),
                              });
                            } else {
                              const newId = this.state.discounts.filter((filtre) => filtre.label === elm.target.textContent)[0]['id'];
                              this.setState({
                                Item: [elm.target.textContent],
                                Items: [...this.state.Items, elm.target.textContent],
                                ItemsId: [
                                  ...this.state.ItemsId,
                                  newId,
                                ],
                              });
                            }
                          }}
                          selected={this.state.Items.includes(val.label)}
                        />
                      );
                    }}
                    itemListPredicate={(query, items) => {
                      return items.filter((item) => item.label.includes(query.toLowerCase()));
                    }}
                    onItemSelect={() => { }}
                    tagRenderer={(item) => item}
                    onRemove={(item) => {
                      let prof;
                      this.state.profils.forEach(p => {
                        p.discounts.forEach(d => {
                          if (d.label === item)
                            prof = d;
                        });
                      });
                      if (prof) {
                        const items = [...this.state.Items];
                        const itemsId = [...this.state.ItemsId];
                        this.setState({ Items: items.filter(i => i !== item), ItemsId: itemsId.filter(d => d !== prof.id) });

                      }
                    }}
                    onClear={() => {
                      this.setState({ Items: [], ItemsId: [] });
                    }}
                  />
                </ControlGroup>
              </FormGroup>

              <FormGroup label={<Trans>active</Trans>} labelFor="input_active">
                <Switch
                  id="input_active"
                  checked={this.state.active}
                  large={true}
                  onChange={(ti) => this.setState({ active: ti.target.checked })}
                />
              </FormGroup>

              <div className="flexbox-center">
                <FormGroup>
                  <Button
                    text={<Trans>edit</Trans>}
                    intent="primary"
                    type="submit"
                    icon="edit"
                    disabled={this.disableProfilUpdateButton()}
                    onClick={async () => {
                      await this.updateProfil();
                    }}
                  />
                  <Button
                    text={<Trans>cancel</Trans>}
                    intent="warning"
                    icon="undo"
                    style={{ marginLeft: '5px' }}
                    onClick={() => this.setState({ editProfil: false })}
                  />
                </FormGroup>
              </div>
            </div>
          </Dialog>

          <div className="flexbox-left">
            {this.state.profils?.map((profil, index) => {
              return (
                <Card
                  key={index}
                  interactive={true}
                  id={profil.id}
                  style={{ marginRight: "5px" }}
                  onClick={async () => {
                    await this.updateDiscounts();

                    const ItemsId = profil.discounts?.map(d => d.id);
                    const Items = profil.discounts?.map(d => d.label);
                    this.setState({ editProfil: true, id: profil.id, label: profil.label, active: profil.active, ItemsId: ItemsId ? ItemsId : [], Items: Items ? Items : [] });
                  }}
                >
                  <div className="vflexbox-center-large">
                    <p>
                      <H5
                        style={{ color: profil.active ? "#2d65b3" : "gray" }}
                      >{profil.label}</H5>
                    </p>
                    <div>

                      {profil.discounts?.map(d => {
                        return <div className="flexbox-center-center">
                          <Tag
                            intent="success"
                            key={`discount_${d.id}`}
                          > {d.label}</Tag> 
                          </div>
                      })
                      }
                    </div>
                  </div>
                </Card>
              );
            })}
          </div>
          <OverlayToaster className={Classes.TOAST_CONTAINER} usePortal={true} ref={this.toasterRef} position={Position.RIGHT_BOTTOM} />
        </Callout>
      </div>
    );
  }
}
